let apikey

export default {
  getKey() {
    return apikey
  },
  setKey(key) {
    apikey = key
  }
}
